import { ChevronDown, Radius, X } from "lucide-react";
import { useState } from "react";

import ToolbarButton from "./toolbar-button";

const borderRadiusOptions = [
  { label: "0px", value: "0" },
  { label: "4px", value: "4" },
  { label: "8px", value: "8" },
  { label: "12px", value: "12" },
  { label: "16px", value: "16" },
  { label: "24px", value: "24" },
  { label: "32px", value: "32" },
  { label: "50px", value: "50" },
  { label: "75px", value: "75" },
  { label: "100px", value: "100" },
];

const BorderStylePicker: React.FC<
  React.ComponentProps<"button"> & {
    editorRef: React.RefObject<HTMLDivElement>;
  }
> = ({ editorRef }) => {
  const [selectedRadius, setSelectedRadius] = useState<string>("0");
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ToolbarButton 
        className="w-fit"
        onClick={() => setIsOpen(true)}
      >
        <div className="flex items-center gap-x-1">
          <Radius />
          Border Radius
          <ChevronDown />
        </div>
      </ToolbarButton>

      {/* مودال با position fixed */}
      {isOpen && (
        <>
          {/* پس‌زمینه تیره */}
          <div 
            className="fixed inset-0 z-[9999]"
            onClick={() => setIsOpen(false)}
          />
          
          {/* محتوای مودال */}
          <div className="fixed z-[10000] bg-white border border-gray-200 rounded-lg shadow-2xl p-4 w-64"
            style={{
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)'
            }}
          >
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-sm font-medium">Border Radius</h3>
              <button
                onClick={() => setIsOpen(false)}
                className="p-1 hover:bg-gray-100 rounded"
              >
                <X className="size-4" />
              </button>
            </div>

            <div className="space-y-1">
              {borderRadiusOptions.map((option) => (
                <button
                  key={option.value}
                  className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-100 rounded flex items-center justify-between transition-colors ${
                    selectedRadius === option.value ? "bg-blue-50 text-blue-600 font-medium" : ""
                  }`}
                  onClick={() => {
                    setSelectedRadius(option.value);
                    if (editorRef.current) {
                      editorRef.current.style.borderRadius = `${option.value}px`;
                    }
                  }}
                >
                  <span>{option.label}</span>
                  {/* پیش‌نمایش گردی */}
                  <span
                    className="inline-block w-6 h-6 border-2 border-gray-400"
                    style={{ borderRadius: `${option.value}px` }}
                  ></span>
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default BorderStylePicker;